"use client";

import * as ToastPrimitive from "@radix-ui/react-toast";
import classNames from "classnames";
import { FC, ReactNode } from "react";

import SuccessIcon from "@/svgs/approve_2.svg";
import CrossIcon from "@/svgs/cross.svg";
import ErrorIcon from "@/svgs/exclamation_triangle.svg";
import InfoIcon from "@/svgs/information_sign.svg";
import { useUIStore } from "stores";

import { Typography } from "../typography";

import styles from "./toast.module.scss";
import { ToastProps } from "./toast.types";

const variantIcon: Record<ToastProps["variant"], ReactNode> = {
  info: <InfoIcon className={styles.leftIcon} />,
  success: <SuccessIcon className={styles.leftIcon} />,
  error: <ErrorIcon className={styles.leftIcon} />,
};

const Toast: FC = () => {
  const { isOpened, data, duration } = useUIStore((state) => state.toast);
  const { closeToast } = useUIStore((state) => state.actions.toast);

  const onOpenChangeHandler = (updatedOpenedValue: boolean) => {
    if (!updatedOpenedValue) {
      closeToast();
    }
  };

  if (!data) return null;

  return (
    <ToastPrimitive.Provider swipeDirection="right" duration={duration ?? 5000}>
      <ToastPrimitive.Root
        open={isOpened}
        className={classNames(styles.toastRoot, styles[data.variant])}
        onOpenChange={onOpenChangeHandler}
      >
        {variantIcon[data.variant]}

        <Typography variant="callout" className={styles.message}>
          {data.message}
        </Typography>

        <CrossIcon className={styles.rightIcon} onClick={closeToast} />
      </ToastPrimitive.Root>

      <ToastPrimitive.Viewport className={styles.toastViewport} />
    </ToastPrimitive.Provider>
  );
};

Toast.displayName = "Toast";

export { Toast };
